import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { ICardDatesPanelButton } from './types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER,
    CLASS_ASIDE_PANEL_ACTIONS_POPUP
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { CARD_SECTION_DATES, CARD_SECTION_DATES_MILESTONE } from '../../constants';
import { CLASS_CARD_DETAILS_SECTION, CLASS_TIME_DROPDOWN, SECTION_CREATION_WAITING_TIME } from '../../../constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { CLASS_DATEPICKER } from 'app/view/react_components/base/components/Datepicker/components/constants';
import { getAsidePanelActionsButtonTooltip } from 'app/view/react_components/aside_panel/asidePanel/helpers/getAsidePanelActionsButtonTooltip';

export function CardDatesPanelButton({
    dueStartFlag,
    isDisabled,
    isMilestone,
    isShow,
    tooltip,
    onClick
}: ICardDatesPanelButton) {
    if (!isShow) return null;

    const className = CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--dates';
    const classNameSection = CLASS_CARD_DETAILS_SECTION + '--dates';

    const { showedProperties, openedProperty, addShowedProperty, isCommentsColumn } = React.useContext(AsidePanelContext);
    const isShowed = showedProperties.has(EAsidePanelProperty.CARD_DATES) && (openedProperty !== EAsidePanelProperty.CARD_START_DATE && openedProperty !== EAsidePanelProperty.CARD_DUE_DATE);
    const [isOpened, setIsOpened] = React.useState(null);
    const onOpened = () => setIsOpened(true);
    const onClosed = () => setIsOpened(false);
    return (
        <AsidePanelActionsButton
            className={className}
            dropdownClassName={`${CLASS_ASIDE_PANEL_ACTIONS_POPUP}--dates`}
            indicatorBoolean={dueStartFlag}
            isDisabled={isDisabled}
            icon={'calendar'}
            isOpened={isOpened}
            notBlurClasses={[
                CLASS_DATEPICKER,
                CLASS_TIME_DROPDOWN,
                CLASS_DATEPICKER + '__time-button',
                CLASS_DATEPICKER + '__time-button-dropdown',
                CLASS_DATEPICKER + '__calendar',
                CLASS_DATEPICKER + '__calendar-select-dropdown',
                CLASS_DATEPICKER + '__hour-switch',
            ]}
            openedProperty={EAsidePanelProperty.CARD_START_DATE}
            sectionSelector={`.${classNameSection}`}
            title={isMilestone ? CARD_SECTION_DATES_MILESTONE : CARD_SECTION_DATES}
            tooltip={tooltip && getAsidePanelActionsButtonTooltip({ value: tooltip })}
            onClick={() => {
                onClick();
                if (!isShowed) {
                    addShowedProperty(EAsidePanelProperty.CARD_DATES, isCommentsColumn);
                    setTimeout(() => {
                        const button = document.querySelector(`.${classNameSection} .settings-section__title-add`) as HTMLButtonElement;
                        if (button) {
                            button.focus();
                            button.click();
                        }
                    }, SECTION_CREATION_WAITING_TIME);
                }
            }}
            onOpen={onOpened}
        >
        </AsidePanelActionsButton>
    );
}
